import React from 'react';
import MuiSnackbar from '@mui/material/Snackbar';
import { SnackbarCloseReason } from '@mui/material/Snackbar';
import { IMessage, EDMessagesContext } from './MessageContext/EDMessageContext';
import shortid from 'shortid';
import EDIconButton from '../Buttons/IconButton/EDIconButton';

interface IProps {
  children?: React.ReactNode;
}

interface IMessageWithId extends IMessage {
  id: string;
}

interface IState {
  open: boolean;
  message: IMessageWithId | null;
}

/**
 * Visar meddelanden från programmet. Används för korta meddelanden som användaren inte behöver göra något åt och som försvinner automatiskt efter en kort tid.
 * Till exempel en bekräftelse på att något gått bra.
 *
 * se https://material.io/guidelines/components/snackbars-toasts.html#
 */
class EDMessages extends React.PureComponent<IProps, IState> {
  messageQueue: IMessageWithId[] = [];

  constructor(props: IProps) {
    super(props);

    this.state = { open: false, message: null };
  }

  addMessage = (message: IMessage) => {
    this.messageQueue.push({ ...message, id: shortid.generate() });

    if (!this.state.open) {
      this.processQueue();
    }
  };

  processQueue = () => {
    if (this.messageQueue.length > 0) {
      const nextMessage = this.messageQueue.shift();
      if (nextMessage) {
        this.setState({
          message: nextMessage,
          open: true,
        });
      }
    }
  };

  onClose = (
    event: Event | React.SyntheticEvent<any, Event>,
    reason: SnackbarCloseReason
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ open: false });
  };

  onCloseButtonClick = () => {
    this.setState({ open: false });
  };

  onExited = () => {
    this.processQueue();
  };

  render() {
    return (
      <>
        <EDMessagesContext.Provider value={this.addMessage}>
          {this.props.children}
        </EDMessagesContext.Provider>

        <MuiSnackbar
          key={this.state.message ? this.state.message.id : undefined}
          open={this.state.open}
          autoHideDuration={4000}
          message={
            <div>{this.state.message ? this.state.message.message : null}</div>
          }
          onClose={this.onClose}
          TransitionProps={{ onExited: this.onExited }}
          action={
            <EDIconButton
              tooltip="Stäng"
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={this.onCloseButtonClick}
              margin="none"
              icon="close"
            />
          }
        />
      </>
    );
  }
}

export default EDMessages;
